import { ThemeProvider } from 'styled-components'
import { useSelector } from 'react-redux'

import { noop } from 'lib/functions/noop'
import { ProbateCase } from 'lib/models/probate-case'
import { PRODUCTS } from 'utils/enums'

import TasksList from 'components/tasks-panel/tasks-list'
import ProbateTaskStagesList from './probate-task-stages-list'
import { useTaskStagesContext } from 'components/tasks-panel/context'
import { useEffect } from 'react'

const Tasks = () => {
  const { taskStages, fetchTaskStages, isFetchingTaskStages } =
    useTaskStagesContext()
  const probateCase: ProbateCase = useSelector(
    (state: { probateCase: ProbateCase }) => state.probateCase
  )
  const queryParams = {
    'filter[probateCaseId]': probateCase.id,
    'filter[isNeeded]': true,
    'page[size]': 200,
  }

  useEffect(() => {
    fetchTaskStages()
  }, [fetchTaskStages])

  if (isFetchingTaskStages && taskStages.length === 0) {
    return <div>...Loading</div>
  }

  /**
   * For older probate cases, we don't have task_stages, so we use the TasksList layout
   * which is used for other products where tasks do not have related task_stages
   */
  if (!taskStages || taskStages.length === 0) {
    return (
      <ThemeProvider theme={{ isExpanded: true }}>
        <TasksList
          product={PRODUCTS.PROBATE}
          productId={{ probateCaseId: probateCase.id }}
          queryParams={queryParams}
          isPanelExpanded
          setPanelExpanded={noop}
        />
      </ThemeProvider>
    )
  }

  /** All probate cases created since June 2026, will have taskStages, so we want to use the new Stage-based Tasks layout */
  return (
    <ThemeProvider theme={{ isExpanded: true }}>
      <ProbateTaskStagesList
        probateCaseId={probateCase.id}
        taskStages={taskStages}
      />
    </ThemeProvider>
  )
}

export default Tasks
